import { Route, useActivePageRegistration } from "@hex-insights/router";
import { PageRouteSwitch } from "../../Components";
import { OnboardingDisplayNamePage } from "./DisplayNamePage";
import { onboardingDisplayNamePageInfo } from "./DisplayNamePage/pageinfo";
import { OnboardingIndexPage } from "./IndexPage";
import { onboardingIndexPageInfo } from "./IndexPage/pageinfo";
import { OnboardingNotificationsPage } from "./NotificationsPage";
import { onboardingNotificationsPageInfo } from "./NotificationsPage/pageinfo";
import { onboardingPageInfo } from "./pageinfo";
import { OnboardingPrivacyStatementPage } from "./PrivacyStatementPage";
import { onboardingPrivacyStatementPageInfo } from "./PrivacyStatementPage/pageinfo";
import { OnboardingProfilePage } from "./ProfilePage";
import { onboardingProfilePageInfo } from "./ProfilePage/pageinfo";
import { OnboardingSuccessPage } from "./SuccessPage";
import { onboardingSuccessPageInfo } from "./SuccessPage/pageinfo";

export function OnboardingPage() {
	useActivePageRegistration(onboardingPageInfo);

	return (
		<PageRouteSwitch>
			<Route {...onboardingIndexPageInfo.routeProps}>
				<OnboardingIndexPage />
			</Route>
			<Route {...onboardingPrivacyStatementPageInfo.routeProps}>
				<OnboardingPrivacyStatementPage />
			</Route>
			<Route {...onboardingProfilePageInfo.routeProps}>
				<OnboardingProfilePage />
			</Route>
			<Route {...onboardingDisplayNamePageInfo.routeProps}>
				<OnboardingDisplayNamePage />
			</Route>
			<Route {...onboardingNotificationsPageInfo.routeProps}>
				<OnboardingNotificationsPage />
			</Route>
			<Route {...onboardingSuccessPageInfo.routeProps}>
				<OnboardingSuccessPage />
			</Route>
		</PageRouteSwitch>
	);
}
